import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class LiteralService {
  constructor(
    private utilService: UtilsService,
    private translateService: TranslateService,
    private titleService: Title
  ) {}

  // Templates call this on every change detection cycle, often before the key is known.
  // ngx-translate throws on an empty key, and a throw here aborts the whole view render
  public get(key: string, capitalized: boolean = false, args?: any): string {
    if (!key) return '';
    const res = this.translateService.instant(key, args);
    return capitalized ? this.utilService.capitalize(res) : res;
  }

  public setTitle(key: string, suffix?: string): any {
    this.translateService.get(key).pipe(take(1)).subscribe((res) => {
      this.titleService.setTitle(this.utilService.capitalize(res) + suffix);
    })
  }
}
